export const translations = {
  en: {
    loading: "Loading...",
    // Login page
    login: {
      title: "TEST3 ",
      subtitle: "Access your medical monitoring space",
      patientId: "Patient ID",
      password: "Password",
      patientIdPlaceholder: "Enter your patient ID",
      passwordPlaceholder: "Enter your password",
      signIn: "Sign In",
      signingIn: "Signing in...",
      errors: {
        patientIdRequired: "Please enter your patient ID",
        passwordRequired: "Please enter your password",
        invalidCredentials: "Invalid credentials. Please try again."
      },
      footer: {
        appName: "Charité Web Application",
        tagline: "Clinical Research & Wellness"
      }
    },
    // Welcome page
    welcome: {
      title: "Welcome, {patientId}",
      subtitle: "Your medical monitoring and wellness space",
      dashboard: {
        title: "Dashboard",
        subtitle: "Track your health journey and clinical data"
      },
      items: {
        appointments: {
          title: "Appointments",
          description: "No upcoming appointments scheduled",
          status: "Up to date"
        },
        testResults: {
          title: "Test Results",
          description: "No new results available",
          status: "Up to date"
        },
        treatments: {
          title: "Treatments",
          description: "No ongoing treatments",
          status: "None"
        },
        medicalNotes: {
          title: "Medical Notes",
          description: "No new notes",
          status: "Up to date"
        },
        physicalActivity: {
          title: "Physical Activity",
          description: "Activity tracking recommended",
          status: "Recommended"
        },
        sleepQuality: {
          title: "Sleep Quality",
          description: "Record your sleep data",
          status: "To complete"
        }
      },
      description: "This application is part of a clinical research program aimed at improving medical monitoring and patient wellness. Your data is protected and anonymized.",
      signOut: "Sign Out"
    },
    // Navigation
    navigation: {
      timeline: "Timeline",
      account: "Account",
      settings: "Settings"
    },
    // Account page
    account: {
      studyDescription: "You are a participant for our study:",
      studyName: "Preoperative metabolic optimization in hip arthroplasty: Fasting and symbiotics to modulate immune profile and gut microbiome",
      studyThanks: "We are grateful for your valuable commitment into this study.",
      progress: "Your progress",
      tips: "Tips",
      hydration: "Think about staying well hydrated",
      relax: "Relax",
      movement: "Move as much as you can, even slowly if you need to",
      evaluation: "Your evaluation",
      weightMeasurements: "Weight measurements",
      waistMeasurements: "Waist measurements",
      ketonesMeasurements: "Ketones measurements",
      todayTasks: "→ To the tasks of the day",
      measurements: "Measurements",
      weightLabel: "Weight (kg)",
      waistLabel: "Waist (cm)",
      ketonesLabel: "Ketones (mg/dL)",
      pending: "Pending",
      upToDate: "Up to date",
      tasksToDo: "{count} task to do|{count} tasks to do",
      oneMeasurement: "1 measurement",
      noMeasurement: "No measurement"
    },
    // Language selector
    language: {
      en: "English",
      de: "German"
    },
    // Timeline translations
    timeline: {
      title: "Timeline",
      subtitle: "Your journey progress",
      overallProgress: "Overall Progress",
      completed: "Completed",
      tasks: "Tasks",
      completedOn: "Completed on",
              status: {
          active: "Active",
        pending: "Pending",
          completed: "Completed",
          locked: "🔒 Locked"
        },
      daysLabel: "days",
      phases: {
        baseline: {
          title: "Baseline",
          description: "Erstbewertung und Basis-Messungen"
        },
        "buchinger-fasten-1": {
          title: "Buchinger Fasten · 1",
          description: "Erste Buchinger Fasten-Phase (Tage -20 bis -11)"
        },
        "buchinger-fasten-2": {
          title: "Buchinger Fasten · 2",
          description: "Zweite Buchinger Fasten-Phase (Tage -10 bis -1)"
        },
        "operation": {
          title: "Operation",
          description: "Operationstag"
        },
        "post-operation": {
          title: "Nach der Operation",
          description: "Postoperative Bewertung und Nachsorge"
        },
        "preparation": {
          title: "Vorbereitung auf die Operation",
          description: "Vorbereitungstag vor der Operation"
        },
        // Anciennes phases pour compatibilité (à supprimer plus tard)
        buchinger: {
          title: "Buchinger Fasting", 
          description: "Buchinger fasting protocol phase"
        },
        intermittent: {
          title: "Intermittent Fasting",
          description: "Intermittent fasting and healthy nutrition phase"
        },
        surgery: {
          title: "Surgery",
          description: "Surgery day - preparation tips and guidance"
        },
        "buchinger-post": {
          title: "Buchinger Fasting - Post Surgery",
          description: "Post-surgery Buchinger fasting protocol"
        },
        "final-step": {
          title: "Final step",
          description: "Final assessment and evaluation"
        },
        "post-surgery": {
          title: "After Surgery",
          description: "Post-operative assessment"
        },
        "post-surgery-1month": {
          title: "1 Month After Surgery",
          description: "Post-operative assessment after 1 month"
        },
        "post-surgery-2months": {
          title: "2 Months After Surgery",
          description: "Post-operative assessment after 2 months"
        },
        "post-surgery-3months": {
          title: "3 Months After Surgery",
          description: "Post-operative assessment after 3 months"
        }
      },
      dayTranslations: {
        baseline: {
          "-21": { title: "Day -21 - Baseline Assessment", description: "Initial assessment with questionnaires and baseline measurements" }
        },
        "buchinger-fasten-1": {
          "-20": { title: "Tag -20", description: "Day -20 before the surgery" },
          "-19": { title: "Tag -19", description: "Day -19 before the surgery" },
          "-18": { title: "Tag -18", description: "Day -18 before the surgery" },
          "-17": { title: "Tag -17", description: "Day -17 before the surgery" },
          "-16": { title: "Tag -16", description: "Day -16 before the surgery" },
          "-15": { title: "Tag -15", description: "Day -15 before the surgery" },
          "-14": { title: "Tag -14", description: "Day -14 before the surgery" },
          "-13": { title: "Tag -13", description: "Day -13 before the surgery" },
          "-12": { title: "Tag -12", description: "Day -12 before the surgery" },
          "-11": { title: "Tag -11", description: "Day -11 before the surgery" }
        },
        "buchinger-fasten-2": {
          "-10": { title: "Tag -10", description: "Day -10 before the surgery" },
          "-9": { title: "Tag -9", description: "Day -9 before the surgery" },
          "-8": { title: "Tag -8", description: "Day -8 before the surgery" },
          "-7": { title: "Tag -7", description: "Day -7 before the surgery" },
          "-6": { title: "Tag -6", description: "Day -6 before the surgery" },
          "-5": { title: "Tag -5", description: "Day -5 before the surgery" },
          "-4": { title: "Tag -4", description: "Day -4 before the surgery" },
          "-3": { title: "Tag -3", description: "Day -3 before the surgery" },
          "-2": { title: "Tag -2", description: "Day -2 before the surgery" },
          "-1": { title: "Tag -1", description: "Day -1 before the surgery" }
        },
        "post-operation": {
          "3": { title: "Tag +3", description: "3 days after the surgery" },
          "7": { title: "Tag +7", description: "7 days after the surgery" },
          "21": { title: "Tag +21", description: "21 days after the surgery" },
          "28": { title: "Tag +28", description: "28 days after the surgery" },
          "35": { title: "Tag +35", description: "35 days after the surgery" },
          "42": { title: "Tag +42", description: "42 days after the surgery" },
          "90": { title: "Tag +90", description: "90 days after the surgery" },
          "180": { title: "Tag +180", description: "180 days after the surgery" }
        },
        "preparation": {
          "-1": { title: "Day -1 - Preparation", description: "Preparation day before the operation" }
        },
        buchinger: {
          1: { title: "Tag 1", description: "Fragebögen & Messungen" },
          2: { title: "Tag 2", description: "Buchinger Fasten" },
          3: { title: "Tag 3", description: "Buchinger Fasten" },
          4: { title: "Tag 4", description: "Buchinger Fasten" },
          5: { title: "Tag 5", description: "Buchinger Fasten" }
        },
        intermittent: {
          6: { title: "Tag 6", description: "Intervallfasten" },
          7: { title: "Tag 7", description: "Intervallfasten" },
          8: { title: "Tag 8", description: "Intervallfasten" },
          9: { title: "Tag 9", description: "Intervallfasten" },
          10: { title: "Tag 10", description: "Intervallfasten" },
          11: { title: "Tag 11", description: "Intervallfasten" }
        },
        surgery: {
          12: { title: "Tag 12", description: "Operationstag" }
        },
        "buchinger-post": {
          13: { title: "Tag 13", description: "Post-OP Buchinger" },
          14: { title: "Tag 14", description: "Post-OP Buchinger" },
          15: { title: "Tag 15", description: "Post-OP Buchinger" },
          16: { title: "Tag 16", description: "Post-OP Buchinger" },
          17: { title: "Tag 17", description: "Post-OP Buchinger" }
        },

        "post-surgery": {
          13: { title: "1 Tag nach OP", description: "Messungen" },
          14: { title: "2 Tage nach OP", description: "Messungen" },
          15: { title: "3 Tage nach OP", description: "Messungen" },
          16: { title: "4 Tage nach OP", description: "Messungen" },
          17: { title: "5 Tage nach OP", description: "Messungen & QoR-15" },
          18: { title: "6 Tage nach OP", description: "Messungen" },
          19: { title: "7 Tage nach OP", description: "Messungen & Proben" }
        },
        "post-surgery-1month": {
          42: { title: "1 Monat", description: "Langzeitbewertung" }
        },
        "post-surgery-2months": {
          72: { title: "2 Monate", description: "Fragebögen" }
        },
        "post-surgery-3months": {
          102: { title: "3 Monate", description: "Fragebögen" }
        },
        "final-step": {
          24: { title: "Tag 24", description: "Abschlussbewertung" }
        }
      }
    },
    // Day detail page translations
    dayDetail: {
      back: "Back",
      completed: "Completed",
      tasks: "Tasks",
      completedOn: "Completed on"
    },
    // Task translations
    tasks: {
      "baseline-stool": {
        title: "First Stool Sample",
        description: "Baseline microbiome profiling"
      },
      "baseline-blood": {
        title: "First Blood Sample",
        description: "Baseline immune profiling"
      },
      "baseline-promis33": {
        title: "PROMIS-33 Baseline Assessment",
        description: "PROMIS Profile 33 questionnaire - Baseline assessment"
      },
      "baseline-hoos": {
        title: "HOOS Baseline Assessment",
        description: "Hip disability and Osteoarthritis Outcome Score questionnaire - Baseline assessment"
      },
      "baseline-degs": {
        title: "DEGS Baseline Assessment",
        description: "DEGS questionnaire - Baseline assessment"
      },
      "baseline-infection": {
        title: "Infection Baseline Assessment",
        description: "Infection questionnaire - Baseline assessment"
      },


      "day1-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day1-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day1-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "blood-pressure-day1": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day3-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day3-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day5-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day5-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day7-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day7-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day9-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day9-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day11-blood": {
        title: "Second Blood Sample",
        description: "Pre-surgery immune profiling"
      },
      "day11-stool": {
        title: "Second Stool Sample",
        description: "Pre-surgery microbiome profiling"
      },
      "day11-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day11-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day2-guidance": {
        title: "Daily Guidance",
        description: "Hydration reminders and motivation"
      },
      "day2-input": {
        title: "Structured Input",
        description: "Daily progress tracking"
      },
      "day2-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "day2-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day2-measurements": {
        title: "Body Measurements",
        description: "Weight and waist circumference tracking"
      },
      "blood-pressure-day2": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day3-guidance": {
        title: "Daily Guidance",
        description: "Hydration reminders and motivation"
      },
      "day3-input": {
        title: "Structured Input",
        description: "Daily progress tracking"
      },
      "day3-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "blood-pressure-day3": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day4-guidance": {
        title: "Daily Guidance",
        description: "Hydration reminders and motivation"
      },
      "day4-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day4-input": {
        title: "Structured Input",
        description: "Daily progress tracking"
      },
      "day4-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "blood-pressure-day4": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day4-measurements": {
        title: "Body Measurements",
        description: "Weight and waist circumference tracking"
      },
      "day5-guidance": {
        title: "Daily Guidance",
        description: "Hydration reminders and motivation"
      },
      "day5-input": {
        title: "Structured Input",
        description: "Daily progress tracking"
      },
      "day5-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "blood-pressure-day5": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day6-nutrition": {
        title: "Nutrition Tips",
        description: "Daily healthy nutrition guidance"
      },
      "day6-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day6-lifestyle": {
        title: "Lifestyle Support",
        description: "Healthy lifestyle recommendations"
      },
      "day6-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "blood-pressure-day6": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day6-measurements": {
        title: "Body Measurements",
        description: "Weight and waist circumference tracking"
      },
      "day7-nutrition": {
        title: "Nutrition Tips",
        description: "Daily healthy nutrition guidance"
      },
      "day7-lifestyle": {
        title: "Lifestyle Support",
        description: "Healthy lifestyle recommendations"
      },
      "day7-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "blood-pressure-day7": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day8-nutrition": {
        title: "Nutrition Tips",
        description: "Daily healthy nutrition guidance"
      },
      "day8-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day8-lifestyle": {
        title: "Lifestyle Support",
        description: "Healthy lifestyle recommendations"
      },
      "day8-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "blood-pressure-day8": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day9-nutrition": {
        title: "Nutrition Tips",
        description: "Daily healthy nutrition guidance"
      },
      "day9-lifestyle": {
        title: "Lifestyle Support",
        description: "Healthy lifestyle recommendations"
      },
      "day9-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "blood-pressure-day9": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day10-nutrition": {
        title: "Nutrition Tips",
        description: "Daily healthy nutrition guidance"
      },
      "day10-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day10-lifestyle": {
        title: "Lifestyle Support",
        description: "Healthy lifestyle recommendations"
      },
      "day10-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "blood-pressure-day10": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day11-nutrition": {
        title: "Nutrition Tips",
        description: "Daily healthy nutrition guidance"
      },
      "day11-lifestyle": {
        title: "Lifestyle Support",
        description: "Healthy lifestyle recommendations"
      },
      "day11-ketostix": {
        title: "Daily Ketostix",
        description: "Daily urine ketone testing"
      },
      "blood-pressure-day11": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day24-blood": {
        title: "Final Blood Sample",
        description: "Post-surgery immune profiling"
      },
      "day24-stool": {
        title: "Final Stool Sample",
        description: "Post-surgery microbiome profiling"
      },
      "day24-ohs": {
        title: "OHS Questionnaire",
        description: "Oxford Hip Score questionnaire"
      },
      "day24-sf36": {
        title: "SF-36 Questionnaire (Acute)",
        description: "Short Form 36 Health Survey - acute version (past week)"
      },
      "day24-qor15": {
        title: "QoR-15 Questionnaire",
        description: "Quality of Recovery-15 questionnaire"
      },
      "day13-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day13-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day13-ohs": {
        title: "OHS Questionnaire",
        description: "Oxford Hip Score questionnaire"
      },
      "day13-sf36": {
        title: "SF-36 Questionnaire",
        description: "Short Form 36 Health Survey questionnaire"
      },
      "day13-qor15": {
        title: "QoR-15 Questionnaire",
        description: "Quality of Recovery-15 questionnaire"
      },
      "blood-pressure-day13": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day30-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day30-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day30-ohs": {
        title: "OHS Questionnaire",
        description: "Oxford Hip Score questionnaire"
      },
      "day30-sf36": {
        title: "SF-36 Questionnaire",
        description: "Short Form 36 Health Survey questionnaire"
      },
      "day30-blood": {
        title: "Final Blood Sample",
        description: "Post-surgery immune profiling"
      },
      "day30-stool": {
        title: "Final Stool Sample",
        description: "Post-surgery microbiome profiling"
      },
      "day14-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "blood-pressure-day14": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day15-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "blood-pressure-day15": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day16-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "blood-pressure-day16": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day17-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day17-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "blood-pressure-day17": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day17-qor15": {
        title: "QoR-15 Questionnaire",
        description: "Quality of Recovery-15 questionnaire"
      },
      "day18-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "blood-pressure-day18": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day19-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day19-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day19-stool": {
        title: "Stool Sample",
        description: "Post-surgery microbiome profiling"
      },
      "day19-blood": {
        title: "Blood Sample",
        description: "Post-surgery immune profiling"
      },
      "blood-pressure-day19": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "blood-pressure-day18": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "blood-pressure-day19": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "blood-pressure-day20": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "blood-pressure-day21": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "blood-pressure-day22": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "blood-pressure-day23": {
        title: "Blood Pressure Measurement",
        description: "Systolic (SBP), Diastolic (DBP), and Pulse measurements"
      },
      "day72-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day72-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day72-ohs": {
        title: "OHS Questionnaire",
        description: "Oxford Hip Score questionnaire"
      },
      "day72-sf36": {
        title: "SF-36 Questionnaire",
        description: "Short Form 36 Health Survey questionnaire"
      },
      "day72-promis33": {
        title: "PROMIS-33 Questionnaire",
        description: "PROMIS Profile 33 questionnaire"
      },
      "day102-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day102-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day102-hoos": {
        title: "HOOS Questionnaire",
        description: "Hip disability and Osteoarthritis Outcome Score questionnaire"
      },
      "day102-promis33": {
        title: "PROMIS-33 Questionnaire",
        description: "PROMIS Profile 33 questionnaire"
      },
      "day42-weight": {
        title: "Measurement body weight (kg)",
        description: "Body weight measurement in kilograms"
      },
      "day42-waist": {
        title: "Measurement of waist circumference (cm)",
        description: "Waist circumference measurement in centimeters"
      },
      "day42-hoos": {
        title: "HOOS Questionnaire",
        description: "Hip disability and Osteoarthritis Outcome Score questionnaire"
      },
      "day42-promis33": {
        title: "PROMIS-33 Questionnaire",
        description: "PROMIS Profile 33 questionnaire"
      },
      "day42-blood": {
        title: "Final Blood Sample",
        description: "Post-surgery immune profiling"
      },
      "day42-stool": {
        title: "Final Stool Sample",
        description: "Post-surgery microbiome profiling"
      }
    }
  },
  de: {
    loading: "Laden...",
    // Login page
    login: {
      title: "Patientenanmeldung",
      subtitle: "Zugang zu Ihrem medizinischen Überwachungsbereich",
      patientId: "Patienten-ID",
      password: "Passwort",
      patientIdPlaceholder: "Geben Sie Ihre Patienten-ID ein",
      passwordPlaceholder: "Geben Sie Ihr Passwort ein",
      signIn: "Anmelden",
      signingIn: "Anmeldung läuft...",
      errors: {
        patientIdRequired: "Bitte geben Sie Ihre Patienten-ID ein",
        passwordRequired: "Bitte geben Sie Ihr Passwort ein",
        invalidCredentials: "Ungültige Anmeldedaten. Bitte versuchen Sie es erneut."
      },
      footer: {
        appName: "Charité Web-Anwendung",
        tagline: "Klinische Forschung & Wohlbefinden"
      }
    },
    // Welcome page
    welcome: {
      title: "Willkommen, {patientId}",
      subtitle: "Ihr medizinischer Überwachungs- und Wohlfühlbereich",
      dashboard: {
        title: "Dashboard",
        subtitle: "Verfolgen Sie Ihre Gesundheitsreise und klinische Daten"
      },
      items: {
        appointments: {
          title: "Termine",
          description: "Keine anstehenden Termine geplant",
          status: "Aktuell"
        },
        testResults: {
          title: "Testergebnisse",
          description: "Keine neuen Ergebnisse verfügbar",
          status: "Aktuell"
        },
        treatments: {
          title: "Behandlungen",
          description: "Keine laufenden Behandlungen",
          status: "Keine"
        },
        medicalNotes: {
          title: "Medizinische Notizen",
          description: "Keine neuen Notizen",
          status: "Aktuell"
        },
        physicalActivity: {
          title: "Körperliche Aktivität",
          description: "Aktivitätsverfolgung empfohlen",
          status: "Empfohlen"
        },
        sleepQuality: {
          title: "Schlafqualität",
          description: "Zeichnen Sie Ihre Schlafdaten auf",
          status: "Zu vervollständigen"
        }
      },
      description: "Diese Anwendung ist Teil eines klinischen Forschungsprogramms zur Verbesserung der medizinischen Überwachung und des Patientenwohlbefindens. Ihre Daten sind geschützt und anonymisiert.",
      signOut: "Abmelden"
    },
    // Navigation
    navigation: {
      timeline: "Timeline",
      account: "Konto",
      settings: "Einstellungen"
    },
    // Account page
    account: {
      studyDescription: "Sie sind Teilnehmer unserer Studie:",
      studyName: "Präoperative metabolische Optimierung bei Hüftarthroplastik: Fasten und Symbiotika zur Modulation des Immunprofils und des Darmmikrobioms",
      studyThanks: "Wir sind dankbar für Ihr wertvolles Engagement in dieser Studie.",
      progress: "Ihr Fortschritt",
      tips: "Tipps",
      hydration: "Denken Sie daran, gut hydratisiert zu bleiben",
      relax: "Entspannen Sie sich",
      movement: "Bewegen Sie sich so viel wie möglich, auch langsam wenn nötig",
      evaluation: "Ihre Bewertung",
      weightMeasurements: "Gewichtsmessungen",
      waistMeasurements: "Taillenmessungen",
      ketonesMeasurements: "Ketonmessungen",
      todayTasks: "→ Zu den Aufgaben des Tages",
      measurements: "Messungen",
      weightLabel: "Gewicht (kg)",
      waistLabel: "Taille (cm)",
      ketonesLabel: "Ketone (mg/dL)",
      pending: "Ausstehend",
      upToDate: "Aktuell",
      tasksToDo: "{count} Aufgabe zu erledigen|{count} Aufgaben zu erledigen",
      oneMeasurement: "1 Messung",
      noMeasurement: "Keine Messung"
    },
    // Language selector
    language: {
      en: "Englisch",
      de: "Deutsch"
    },
    // Timeline translations
    timeline: {
      title: "Timeline",
      subtitle: "Ihr Fortschritt",
      overallProgress: "Gesamtfortschritt",
      completed: "Abgeschlossen",
      tasks: "Aufgaben",
      completedOn: "Abgeschlossen am",
              status: {
          active: "Aktiv",
        pending: "Ausstehend",
          completed: "Abgeschlossen",
          locked: "🔒 Gesperrt"
        },
      daysLabel: "Tage",
      phases: {
        baseline: {
          title: "Baseline",
          description: "Erstbewertung und Basis-Messungen"
        },
        "buchinger-fasten-1": {
          title: "Buchinger Fasten - 1",
          description: "Erste Buchinger Fasten-Phase (Tage -20 bis -11)"
        },
        "buchinger-fasten-2": {
          title: "Buchinger Fasten - 2",
          description: "Zweite Buchinger Fasten-Phase (Tage -10 bis -1)"
        },
        "operation": {
          title: "Operation",
          description: "Operationstag"
        },
        "post-operation": {
          title: "Nach der Operation",
          description: "Postoperative Bewertung und Nachsorge"
        },
        "preparation": {
          title: "Vorbereitung auf die Operation",
          description: "Vorbereitungstag vor der Operation"
        },
        // Anciennes phases pour compatibilité (à supprimer plus tard)
        buchinger: {
          title: "Buchinger Fasten", 
          description: "Buchinger Fastenprotokoll-Phase"
        },
        intermittent: {
          title: "Intervallfasten 14/10",
          description: "Intervallfasten und gesunde Ernährung Phase"
        },
        surgery: {
          title: "Operation",
          description: "Operationstag - Vorbereitungstipps und Anleitung"
        },
        "buchinger-post": {
          title: "Buchinger Fasten – Nach Operation",
          description: "Postoperative Buchinger-Fasten-Phase"
        },
        "final-step": {
          title: "Finale Bewertung",
          description: "Abschlussbewertung und Auswertung"
        },
        "post-surgery": {
          title: "Nach der Operation",
          description: "Postoperative Bewertung"
        },
        "post-surgery-1month": {
          title: "1 Monat nach der Operation",
          description: "Postoperative Bewertung nach 1 Monat"
        },
        "post-surgery-2months": {
          title: "2 Monate nach der Operation",
          description: "Postoperative Bewertung nach 2 Monaten"
        },
        "post-surgery-3months": {
          title: "3 Monate nach der Operation",
          description: "Postoperative Bewertung nach 3 Monaten"
        }
      },
      dayTranslations: {
        baseline: {
          "-21": { title: "Tag -21 - Basisbewertung", description: "Erstbewertung mit Fragebögen und Basis-Messungen" }
        },
        "buchinger-fasten-1": {
          "-20": { title: "Tag -20", description: "Tag -20 vor der Operation" },
          "-19": { title: "Tag -19", description: "Tag -19 vor der Operation" },
          "-18": { title: "Tag -18", description: "Tag -18 vor der Operation" },
          "-17": { title: "Tag -17", description: "Tag -17 vor der Operation" },
          "-16": { title: "Tag -16", description: "Tag -16 vor der Operation" },
          "-15": { title: "Tag -15", description: "Tag -15 vor der Operation" },
          "-14": { title: "Tag -14", description: "Tag -14 vor der Operation" },
          "-13": { title: "Tag -13", description: "Tag -13 vor der Operation" },
          "-12": { title: "Tag -12", description: "Tag -12 vor der Operation" },
          "-11": { title: "Tag -11", description: "Tag -11 vor der Operation" }
        },
        "buchinger-fasten-2": {
          "-10": { title: "Tag -10", description: "Tag -10 vor der Operation" },
          "-9": { title: "Tag -9", description: "Tag -9 vor der Operation" },
          "-8": { title: "Tag -8", description: "Tag -8 vor der Operation" },
          "-7": { title: "Tag -7", description: "Tag -7 vor der Operation" },
          "-6": { title: "Tag -6", description: "Tag -6 vor der Operation" },
          "-5": { title: "Tag -5", description: "Tag -5 vor der Operation" },
          "-4": { title: "Tag -4", description: "Tag -4 vor der Operation" },
          "-3": { title: "Tag -3", description: "Tag -3 vor der Operation" },
          "-2": { title: "Tag -2", description: "Tag -2 vor der Operation" },
          "-1": { title: "Tag -1", description: "Tag -1 vor der Operation" }
        },
        "post-operation": {
          "3": { title: "Tag +3", description: "3 Tage nach der Operation" },
          "7": { title: "Tag +7", description: "7 Tage nach der Operation" },
          "21": { title: "Tag +21", description: "21 Tage nach der Operation" },
          "28": { title: "Tag +28", description: "28 Tage nach der Operation" },
          "35": { title: "Tag +35", description: "35 Tage nach der Operation" },
          "42": { title: "Tag +42", description: "42 Tage nach der Operation" },
          "90": { title: "Tag +90", description: "90 Tage nach der Operation" },
          "180": { title: "Tag +180", description: "180 Tage nach der Operation" }
        },
        "preparation": {
          "-1": { title: "Tag -1 - Vorbereitung", description: "Vorbereitungstag vor der Operation" }
        },
        buchinger: {
          1: { title: "Tag 1", description: "Fragebögen & Messungen" },
          2: { title: "Tag 2", description: "Buchinger Fasten" },
          3: { title: "Tag 3", description: "Buchinger Fasten" },
          4: { title: "Tag 4", description: "Buchinger Fasten" },
          5: { title: "Tag 5", description: "Buchinger Fasten" }
        },
        intermittent: {
          6: { title: "Tag 6", description: "Intervallfasten" },
          7: { title: "Tag 7", description: "Intervallfasten" },
          8: { title: "Tag 8", description: "Intervallfasten" },
          9: { title: "Tag 9", description: "Intervallfasten" },
          10: { title: "Tag 10", description: "Intervallfasten" },
          11: { title: "Tag 11", description: "Intervallfasten" }
        },
        surgery: {
          12: { title: "Tag 12", description: "Operationstag" }
        },
        "buchinger-post": {
          13: { title: "Tag 13", description: "Post-OP Buchinger" },
          14: { title: "Tag 14", description: "Post-OP Buchinger" },
          15: { title: "Tag 15", description: "Post-OP Buchinger" },
          16: { title: "Tag 16", description: "Post-OP Buchinger" },
          17: { title: "Tag 17", description: "Post-OP Buchinger" }
        },

        "post-surgery": {
          13: { title: "1 Tag nach OP", description: "Messungen" },
          14: { title: "2 Tage nach OP", description: "Messungen" },
          15: { title: "3 Tage nach OP", description: "Messungen" },
          16: { title: "4 Tage nach OP", description: "Messungen" },
          17: { title: "5 Tage nach OP", description: "Messungen & QoR-15" },
          18: { title: "6 Tage nach OP", description: "Messungen" },
          19: { title: "7 Tage nach OP", description: "Messungen & Proben" }
        },
        "post-surgery-1month": {
          42: { title: "1 Monat", description: "Langzeitbewertung" }
        },
        "post-surgery-2months": {
          72: { title: "2 Monate", description: "Fragebögen" }
        },
        "post-surgery-3months": {
          102: { title: "3 Monate", description: "Fragebögen" }
        },
        "final-step": {
          24: { title: "Tag 24", description: "Abschlussbewertung" }
        }
      }
    },
    // Day detail page translations
    dayDetail: {
      back: "Zurück",
      completed: "Abgeschlossen",
      tasks: "Aufgaben",
      completedOn: "Abgeschlossen am"
    },
    // Task translations
    tasks: {
      "baseline-stool": {
        title: "Erste Stuhlprobe",
        description: "Baseline-Mikrobiom-Profilierung"
      },
      "baseline-blood": {
        title: "Erste Blutprobe",
        description: "Baseline-Immun-Profilierung"
      },
      "baseline-promis33": {
        title: "PROMIS-33 Basisbewertung",
        description: "PROMIS Profile 33 Fragebogen - Basisbewertung"
      },
      "baseline-hoos": {
        title: "HOOS Basisbewertung",
        description: "Hip disability and Osteoarthritis Outcome Score Fragebogen - Basisbewertung"
      },
      "baseline-degs": {
        title: "DEGS Basisbewertung",
        description: "DEGS Fragebogen - Basisbewertung"
      },
      "baseline-infection": {
        title: "Infektion Basisbewertung",
        description: "Infektion Fragebogen - Basisbewertung"
      },

      "day1-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day1-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day1-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "blood-pressure-day1": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day3-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day3-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day5-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day5-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day7-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day7-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day9-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day9-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day11-blood": {
        title: "Zweite Blutprobe",
        description: "Pre-Operation Immun-Profilierung"
      },
      "day11-stool": {
        title: "Zweite Stuhlprobe",
        description: "Pre-Operation Mikrobiom-Profilierung"
      },
      "day11-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day11-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day2-guidance": {
        title: "Tägliche Anleitung",
        description: "Hydratationserinnerungen und Motivation"
      },
      "day2-input": {
        title: "Strukturierte Eingabe",
        description: "Tägliche Fortschrittsverfolgung"
      },
      "day2-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day2-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "blood-pressure-day2": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day2-measurements": {
        title: "Körpermessungen",
        description: "Gewicht und Taillenumfang verfolgen"
      },
      "day3-guidance": {
        title: "Tägliche Anleitung",
        description: "Hydratationserinnerungen und Motivation"
      },
      "day3-input": {
        title: "Strukturierte Eingabe",
        description: "Tägliche Fortschrittsverfolgung"
      },
      "day3-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "blood-pressure-day3": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day4-guidance": {
        title: "Tägliche Anleitung",
        description: "Hydratationserinnerungen und Motivation"
      },
      "day4-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day4-input": {
        title: "Strukturierte Eingabe",
        description: "Tägliche Fortschrittsverfolgung"
      },
      "day4-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "blood-pressure-day4": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day4-measurements": {
        title: "Körpermessungen",
        description: "Gewicht und Taillenumfang verfolgen"
      },
      "day5-guidance": {
        title: "Tägliche Anleitung",
        description: "Hydratationserinnerungen und Motivation"
      },
      "day5-input": {
        title: "Strukturierte Eingabe",
        description: "Tägliche Fortschrittsverfolgung"
      },
      "day5-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "blood-pressure-day5": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day6-nutrition": {
        title: "Ernährungstipps",
        description: "Tägliche gesunde Ernährungsanleitung"
      },
      "day6-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day6-lifestyle": {
        title: "Lebensstil-Unterstützung",
        description: "Gesunde Lebensstil-Empfehlungen"
      },
      "day6-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "blood-pressure-day6": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day6-measurements": {
        title: "Körpermessungen",
        description: "Gewicht und Taillenumfang verfolgen"
      },
      "day7-nutrition": {
        title: "Ernährungstipps",
        description: "Tägliche gesunde Ernährungsanleitung"
      },
      "day7-lifestyle": {
        title: "Lebensstil-Unterstützung",
        description: "Gesunde Lebensstil-Empfehlungen"
      },
      "day7-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "blood-pressure-day7": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day8-nutrition": {
        title: "Ernährungstipps",
        description: "Tägliche gesunde Ernährungsanleitung"
      },
      "day8-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day8-lifestyle": {
        title: "Lebensstil-Unterstützung",
        description: "Gesunde Lebensstil-Empfehlungen"
      },
      "day8-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "blood-pressure-day8": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day9-nutrition": {
        title: "Ernährungstipps",
        description: "Tägliche gesunde Ernährungsanleitung"
      },
      "day9-lifestyle": {
        title: "Lebensstil-Unterstützung",
        description: "Gesunde Lebensstil-Empfehlungen"
      },
      "day9-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "blood-pressure-day9": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day10-nutrition": {
        title: "Ernährungstipps",
        description: "Tägliche gesunde Ernährungsanleitung"
      },
      "day10-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day10-lifestyle": {
        title: "Lebensstil-Unterstützung",
        description: "Gesunde Lebensstil-Empfehlungen"
      },
      "day10-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "day10-blood-pressure": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "blood-pressure-day10": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day11-nutrition": {
        title: "Ernährungstipps",
        description: "Tägliche gesunde Ernährungsanleitung"
      },
      "day11-lifestyle": {
        title: "Lebensstil-Unterstützung",
        description: "Gesunde Lebensstil-Empfehlungen"
      },
      "day11-ketostix": {
        title: "Tägliche Ketostix",
        description: "Tägliche Urin-Keton-Tests"
      },
      "day11-blood-pressure": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "blood-pressure-day11": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day24-blood": {
        title: "Finale Blutprobe",
        description: "Post-Operation Immun-Profilierung"
      },
      "day24-stool": {
        title: "Finale Stuhlprobe",
        description: "Post-Operation Mikrobiom-Profilierung"
      },

      "day24-qor15": {
        title: "QoR-15 Fragebogen",
        description: "Quality of Recovery-15 Fragebogen"
      },
      "day13-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day13-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day13-ohs": {
        title: "OHS Fragebogen",
        description: "Oxford Hip Score Fragebogen"
      },
      "day13-sf36": {
        title: "SF-36 Fragebogen",
        description: "Short Form 36 Health Survey Fragebogen"
      },
      "day13-qor15": {
        title: "QoR-15 Fragebogen",
        description: "Quality of Recovery-15 Fragebogen"
      },
      "blood-pressure-day13": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day30-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day30-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day30-ohs": {
        title: "OHS Fragebogen",
        description: "Oxford Hip Score Fragebogen"
      },
      "day30-sf36": {
        title: "SF-36 Fragebogen",
        description: "Short Form 36 Health Survey Fragebogen"
      },
      "day30-blood": {
        title: "Finale Blutprobe",
        description: "Post-Operation Immun-Profilierung"
      },
      "day30-stool": {
        title: "Finale Stuhlprobe",
        description: "Post-Operation Mikrobiom-Profilierung"
      },
      "day14-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "blood-pressure-day14": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day15-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "blood-pressure-day15": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day16-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "blood-pressure-day16": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day17-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day17-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "blood-pressure-day17": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day17-qor15": {
        title: "QoR-15 Fragebogen",
        description: "Quality of Recovery-15 Fragebogen"
      },
      "day18-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "blood-pressure-day18": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day19-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day19-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day19-stool": {
        title: "Stuhlprobe",
        description: "Post-Operation Mikrobiom-Profilierung"
      },
      "day19-blood": {
        title: "Blutprobe",
        description: "Post-Operation Immun-Profilierung"
      },
      "blood-pressure-day19": {
        title: "Blutdruckmessung",
        description: "Systolischer (SBP), Diastolischer (DBP) und Puls Messungen"
      },
      "day72-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day72-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day72-ohs": {
        title: "OHS Fragebogen",
        description: "Oxford Hip Score Fragebogen"
      },
      "day72-sf36": {
        title: "SF-36 Fragebogen",
        description: "Short Form 36 Health Survey Fragebogen"
      },
      "day72-promis33": {
        title: "PROMIS-33 Fragebogen",
        description: "PROMIS Profile 33 Fragebogen"
      },
      "day102-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day102-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day102-ohs": {
        title: "OHS Fragebogen",
        description: "Oxford Hip Score Fragebogen"
      },
      "day102-hoos": {
        title: "HOOS Fragebogen",
        description: "Hip disability and Osteoarthritis Outcome Score Fragebogen"
      },
      "day102-sf36": {
        title: "SF-36 Fragebogen",
        description: "Short Form 36 Health Survey Fragebogen"
      },
      "day102-promis33": {
        title: "PROMIS-33 Fragebogen",
        description: "PROMIS Profile 33 Fragebogen"
      },
      "day42-weight": {
        title: "Messung des Körpergewichts (kg)",
        description: "Körpergewichts-Messung in Kilogramm"
      },
      "day42-waist": {
        title: "Messung des Taillenumfangs (cm)",
        description: "Taillenumfang-Messung in Zentimetern"
      },
      "day42-ohs": {
        title: "OHS Fragebogen",
        description: "Oxford Hip Score Fragebogen"
      },
      "day42-hoos": {
        title: "HOOS Fragebogen",
        description: "Hip disability and Osteoarthritis Outcome Score Fragebogen"
      },
      "day42-sf36": {
        title: "SF-36 Fragebogen",
        description: "Short Form 36 Health Survey Fragebogen"
      },
      "day42-promis33": {
        title: "PROMIS-33 Fragebogen",
        description: "PROMIS Profile 33 Fragebogen"
      },
      "day42-blood": {
        title: "Finale Blutprobe",
        description: "Post-Operation Immun-Profilierung"
      },
      "day42-stool": {
        title: "Finale Stuhlprobe",
        description: "Post-Operation Mikrobiom-Profilierung"
      }
    }
  }
};

// Helper function to replace placeholders in strings
export const formatString = (str, replacements) => {
  return str.replace(/\{(\w+)\}/g, (match, key) => {
    return replacements[key] || match;
  });
}; 